interface ResourceWithPermissions {
  permission_info?: {
    effective_permission?: 'edit' | 'view' | 'no-access';
  };
  is_locked?: boolean;
  owner_id?: string | null;
}

export type ResourceDisplayMode = 'edit' | 'view' | 'no-access';

export const getResourceDisplayMode = (
  resource: ResourceWithPermissions,
  isResourceSharingEnabled: boolean,
  currentUserId: string,
  isViewUrl = false
): ResourceDisplayMode => {
  const effectivePermission = resource.permission_info?.effective_permission;

  if (isResourceSharingEnabled && effectivePermission !== 'edit') {
    return effectivePermission === 'view' ? 'view' : 'no-access';
  }

  if (!isResourceSharingEnabled && isViewUrl) {
    return 'view';
  }

  if (resource.is_locked && resource.owner_id !== currentUserId) {
    return 'view';
  }

  return 'edit';
};

export const getResourceDisplayState = (
  resource: ResourceWithPermissions | undefined,
  resourceSharingEnabled: boolean | undefined,
  currentUserId: string,
  isViewUrl: boolean
) => {
  const displayMode = resource
    ? getResourceDisplayMode(resource, !!resourceSharingEnabled, currentUserId, isViewUrl)
    : undefined;

  return {
    displayMode,
    shouldUseViewMode: displayMode === 'view'
  };
};
